import { hrBaseApi } from "app/services/HrBaseApi";

export const homeDefaultApi = hrBaseApi.injectEndpoints({
  endpoints: (builder) => ({

    // List of Business Units
    getBusinessUnitList: builder.query({
      query: () => ({
        url: `/Felix/PartnerListreportDropdown/`,
        method: "GET",
      }),
    }),

    // Department wise employee (All BU)
    getDepartmentwiseEmployeeForAll: builder.query({
      query: () => ({
        url: `/Felix/Departmentwiseemployeeforall/`,
        method: "GET",
      }),
    }),

    // Department wise employee (Specific Partner)
    getDepartmentwiseEmployee: builder.query({
      query: (partnerId) => ({
        url: `/Felix/Departmentwiseemployee/?Partner_Id=${partnerId}`,
        method: "GET",
      }),
    }),

    // Age wise employee (All BU)
    getAgewiseEmployeeForAll: builder.query({
      query: () => ({
        url: `/Felix/Agewiseemployeeforall/`,
        method: "GET",
      }),
    }),

    // Age wise employee (Specific Partner)
    getAgewiseEmployee: builder.query({
      query: (partnerId) => ({
        url: `/Felix/Agewiseemployee/?Partner_Id=${partnerId}`,
        method: "GET",
      }),
    }),

       // Experience wise employee (All BU)
    getExperiencewiseEmployeeForAll: builder.query({
      query: () => ({
        url: `/Felix/Experiencewiseemployeeforall/`,
        method: "GET",
      }),
    }),

    // Experience wise employee (Specific Partner)
    getExperiencewiseEmployee: builder.query({
      query: (partnerId) => ({
        url: `/Felix/Experiencewiseemployee/?Partner_Id=${partnerId}`,
        method: "GET",
      }),
    }),

       // Gender wise employee (All BU)
    getGenderwiseEmployeeForAll: builder.query({
      query: () => ({
        url: `/Felix/Genderwiseemployeeforall/`,
        method: "GET",
      }),
    }),

    // Gender wise employee (Specific Partner)
    getGenderwiseEmployee: builder.query({
      query: (partnerId) => ({
        url: `/Felix/Genderwiseemployee/?Partner_Id=${partnerId}`,
        method: "GET",
      }),
    }),


  }),
});

export const {
  useGetBusinessUnitListQuery,
  useLazyGetBusinessUnitListQuery,

  useGetDepartmentwiseEmployeeForAllQuery,
  useLazyGetDepartmentwiseEmployeeForAllQuery,
  useGetDepartmentwiseEmployeeQuery,
  useLazyGetDepartmentwiseEmployeeQuery,

  useGetAgewiseEmployeeForAllQuery,
  useLazyGetAgewiseEmployeeForAllQuery,
  useGetAgewiseEmployeeQuery,
  useLazyGetAgewiseEmployeeQuery,

  useGetExperiencewiseEmployeeForAllQuery,
  useLazyGetExperiencewiseEmployeeForAllQuery,
  useGetExperiencewiseEmployeeQuery,
  useLazyGetExperiencewiseEmployeeQuery,

   useGetGenderwiseEmployeeForAllQuery,
  useLazyGetGenderwiseEmployeeForAllQuery,
  useGetGenderwiseEmployeeQuery,
  useLazyGetGenderwiseEmployeeQuery,

} = homeDefaultApi;